"use strict";
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideMapState = exports.AreaProjectDeliverable = exports.GisField = exports.ResultsStats = exports.Metric = exports.Microorganism = exports.AreaFarmMetrics = exports.AreaFarmCategoryMetrics = exports.AreaGeneralMetrics = exports.BeCropMetricsBlock = exports.ComparisonReport = exports.AreaProjectVSPhChMetricCategory = exports.BeCropMetricCategory = exports.AreaProjectProposal = exports.PlusReport = exports.AreaCertificate = exports.MultiDimmensionalComparison = exports.BeCropComparisonMetric = exports.PhChMetric = exports.BioMetric = exports.BeCropMetric = exports.Category = exports.BioMetricCategory = exports.AreaProjectBuilt = exports.AgInsight = exports.AgronomicInsight = exports.AreaProjectAgronomicInsights = exports.RecommendationBasedOnAgronomicInsight = exports.AreaProjectSamples = exports.Entity = exports.CATEGORIES_LIBRARY = exports.CATEGORIES_ORDER = void 0;
// import { crop } from '@becrop/components/Modules/Common/interfaces/subclient_i';
const Score_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Score"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
const trans_1 = require("@common/tsutils/trans");
const axios_1 = __importDefault(require("axios"));
const download_1 = require("@common/utils/download");
const format_1 = require("ol/format");
const ColorLibController_1 = __importDefault(require("../Controllers/ColorLibController"));
const colorController = new ColorLibController_1.default();
const Utils_1 = require("@becrop/components/Map/Utils");
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const GeoEntities_1 = require("@becrop/abstract/Models/GeoEntities");
const NeedMap_1 = require("@becrop/abstract/Models/NeedMap");
const IndividualStats_1 = require("@becrop/abstract/Models/IndividualStats");
//import Sample from '@common/models/Sample';
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const Recommendation_1 = __importDefault(require("@becrop/abstract/Models/Recommendation"));
const MAP_CONTROLLER = new Controller_1.default();
exports.CATEGORIES_ORDER = [
    'nutrition', 'carbon_pathways', 'diseases_and_biocontrol',
    'microbial_phytohormone', 'stress_adaptation', 'microbial_phytohormone_and_stress_adaptation',
    'global_indexes', 'biological_soil_quality'
];
exports.CATEGORIES_LIBRARY = [
    {
        name: (0, trans_1.trans)('results_view_map.categories.NUT'),
        code: 'NUT',
        order: -1,
        hooks: ['NF-N', 'NF-P', 'NF-K', 'NF-Fe', 'NF-Zn', 'NF-Mn', 'NF-S', 'NF-Ca', 'NF-Cu', 'NF-Mg', 'NF-Cl'],
        metrics: [],
    },
    {
        name: (0, trans_1.trans)('results_view_map.categories.C'),
        code: 'C',
        order: -1,
        hooks: ['NF-C'],
        metrics: [],
    },
    {
        name: (0, trans_1.trans)('results_view_map.categories.PGPs'),
        code: 'PGPs',
        order: -1,
        hooks: ['STR', 'HOM'],
        metrics: [],
    },
    {
        name: (0, trans_1.trans)('results_view_map.categories.HLT'),
        code: 'HLT',
        order: -1,
        hooks: ['HLT', 'BIO'],
        metrics: [],
    },
    {
        name: (0, trans_1.trans)('results_view_map.categories.BIO'),
        code: 'BIO',
        order: -1,
        hooks: ['SHI'],
        metrics: [],
    },
    {
        name: (0, trans_1.trans)('results_view_map.categories.GS'),
        code: 'GS',
        order: -1,
        hooks: ['GS'],
        metrics: [],
    },
];
class Entity {
    constructor(obj) {
        this.type = obj.type || '';
        this.label = obj.label || '';
        this.name = obj.name || '';
        this.id = obj.id || -1;
        this.projId = obj.projId || -1;
        this.acreage = obj.acreage || new Acreage_1.default(-1, '');
        this.projType = obj.projType || '';
        this.cropLabel = obj.cropLabel || '';
        this.cropColor = obj.cropLabel || '';
        this.dateRangeLabel = obj.dateRangeLabel || '';
    }
}
exports.Entity = Entity;
class AreaProjectSamples {
    constructor(obj) {
        var _a, _b;
        this.code = obj.code || '';
        this.coordenates = obj.coordenates || '';
        this.crop = obj.crop || new Crop_1.default({});
        this.units = obj.units || 'BCS';
        this.score = (_a = obj.score) !== null && _a !== void 0 ? _a : -1;
        this.rank = (_b = obj.rank) !== null && _b !== void 0 ? _b : -1;
        this.scale = obj.scale || '';
    }
    setScale(newScale) {
        this.scale = newScale;
    }
    get color() {
        return (this.scale === 'hlt') ?
            colorController.getDiseasesColor(colorController.getRankFromScore(this.score).toString()) :
            colorController.getRankColor(colorController.getRankFromScore(this.score).toString());
    }
    get transparency() {
        return (this.category === 'HLT') ?
            colorController.getRankTransparency(colorController.getRankFromScore(this.score).toString(), 'diseases') :
            colorController.getRankTransparency(colorController.getRankFromScore(this.score).toString(), '');
    }
    async downloadReportPDF(anonymize) {
        let url = `/data/results/report/pdf/${this.code}`;
        let name = this.code;
        if (anonymize) {
            url = `${url}?anonymize=true`;
            name = 'sample_report';
        }
        try {
            await axios_1.default
                .get(url, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                },
            })
                .then((res) => {
                (0, download_1.downloadPDFWithDynamicName)(res, `${name}.pdf`);
            })
                .catch((error) => {
                console.log(error);
            });
        }
        catch (e) {
        }
    }
}
exports.AreaProjectSamples = AreaProjectSamples;
class RecommendationBasedOnAgronomicInsight {
    constructor(obj) {
        this.bioagent_category_name = obj.bioagent_category_name || '';
        this.bioagent_name = obj.bioagent_name || '';
        this.product_composition = obj.product_composition || '';
    }
}
exports.RecommendationBasedOnAgronomicInsight = RecommendationBasedOnAgronomicInsight;
class AreaProjectAgronomicInsights {
    constructor(obj) {
        this.insight = obj.insight || '';
        this.recommendations = obj.recommendations || new Array();
        this.tested_values = obj.tested_values || [];
        this.optimal_values = obj.optimal_values || [];
        this.positive_insight = obj.positive_insight || '';
        this.keywords = obj.keywords || [];
        this.show_insight = obj.show_insight || false;
        this.show_positive_insight = obj.show_positive_insight || false;
        this.show_keywords = obj.show_keywords || false;
        this.in_optimal_rank = obj.in_optimal_rank || false;
        this.optimal_values = this.optimal_values.sort((a, b) => a - b);
    }
    get optimalRankMin() {
        return this.optimal_values[0] === 0 ? 1 : this.optimal_values[0];
    }
    get optimalRankMax() {
        return this.optimal_values[this.optimal_values.length - 1];
    }
    get optimalRankPercMin() {
        const percMins = [0, 20, 40, 60, 80];
        return percMins[this.optimalRankMin - 1];
    }
    get optimalRankPercMax() {
        const percMax = [19, 39, 59, 79, 100];
        return percMax[this.optimalRankMax - 1];
    }
}
exports.AreaProjectAgronomicInsights = AreaProjectAgronomicInsights;
class AgronomicInsight {
    constructor(obj) {
        this.insight = obj.insight || '';
        this.field = obj.field || '';
        this.area = obj.area || '';
        this.areaShape = obj.area || '';
        this.category = obj.category || '';
        this.metric = obj.metric || '';
        this.rank = obj.rank || 0;
        this.scale = obj.scale || '';
        this.defaultMessage = obj.defaultMessage || '';
    }
}
exports.AgronomicInsight = AgronomicInsight;
class AgInsight {
    constructor(obj) {
        this.insight = obj.insight || '';
        this.field = obj.field || new GeoEntities_1.Field({});
        this.metric = obj.metric || new BioMetric({}, {});
    }
}
exports.AgInsight = AgInsight;
class AreaProjectBuilt {
    constructor(obj) {
        var _a, _b, _c;
        this.area_crop = obj.area_crop || new Crop_1.default({});
        this.area_id = (_a = obj.area_id) !== null && _a !== void 0 ? _a : -1;
        this.farm_id = obj.farm_id || -1;
        this.area_name = obj.area_name || '';
        this.extension = obj.extension || '';
        this.extension_units = obj.extension_units || '';
        this.acreage = new Acreage_1.default(parseFloat(this.extension), this.extension_units);
        this.label = obj.label || '';
        this.name_project = obj.name_project || '';
        this.project_id = (_b = obj.project_id) !== null && _b !== void 0 ? _b : -1;
        this.project_type = obj.project_type || '';
        this.polygon = obj.polygon || '';
        this.downloaded = obj.downloaded || false;
        this.category = obj.category || '';
        this.is_synthetic = obj.is_synthetic || false;
        this.selectable = false;
        this.recommendationsNumber = (_c = obj.recommendationsNumber) !== null && _c !== void 0 ? _c : -1;
        this.dateRange = obj.dateRange || [];
        this.cropsInFields = obj.cropsInFields || new Array();
    }
    setGeodata(g) {
        this.polygon = g;
    }
    async fetchGeodata() {
        try {
            if (this.polygon.length == 0) {
                const url = `/project/${this.project_id}/area/${this.area_id}/geodata`;
                const request = await fetch(url);
                const response = await request.json();
                this.setGeodata(response.geodata);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    get dateRangeLabel() {
        if (this.dateRange.length > 0) {
            const range = this.dateRange.map((s) => s.replace(' ', ''));
            if (range.length == 1) {
                return range[0];
            }
            else {
                if (range.length === 2) {
                    if (range[0] === range[1])
                        return range[0];
                    return range.join(' - ');
                }
            }
        }
        return '---';
    }
}
exports.AreaProjectBuilt = AreaProjectBuilt;
class BioMetricCategory {
    constructor(obj) {
        var _a, _b;
        this.name = obj.name || '-';
        this.code = obj.code || '-';
        this.order = (_a = obj.order) !== null && _a !== void 0 ? _a : -1;
        this.hooks = obj.hooks || [];
        this.metrics = obj.metrics || new Array();
        this.lastMetricIx = (_b = obj.lastMetricIx) !== null && _b !== void 0 ? _b : -1;
    }
}
exports.BioMetricCategory = BioMetricCategory;
class Category {
    constructor(obj) {
        this.slug = obj.slug || '';
        this.name = obj.name || '';
    }
}
exports.Category = Category;
class BeCropMetric {
    constructor(obj) {
        var _a;
        this.name = obj.name || '#Metric';
        this.code_name = obj.code_name || '000000';
        this.unit = obj.unit || '';
        this.score = (_a = obj.score) !== null && _a !== void 0 ? _a : -1;
        this.rank = obj.rank || colorController.getRankFromScore(this.score);
        this.samples = obj.samples || new Array();
        this.public = obj.public || false;
        this.rasterUrl = obj.rasterUrl || '';
        this.type_code = obj.type_code || '';
        this.category_metric = obj.category || new Category({});
        this.category_map = obj.category_map || new Category({});
    }
}
exports.BeCropMetric = BeCropMetric;
class BioMetric extends BeCropMetric {
    constructor(bcObj, bioObj) {
        super(bcObj);
        this.category = bioObj.category || '';
        this.raw_rank = bioObj.raw_rank || colorController.getRankFromScore(bioObj.score);
        this.scoreBC = new Score_1.default(bioObj.score, '');
        this.scale = bioObj.scale || 'hlt';
        this.isBeneficial = bioObj.beneficial || false;
        this.dimension = bioObj.dimension || 'bio';
        this.stats = bioObj.stats || new IndividualStats_1.BecropStats({});
        this.resultOrigin = bioObj.resultOrigin || '';
        this.insights = bioObj.insights || new AreaProjectAgronomicInsights({});
        this.microorganisms = bioObj.microorganisms || new Array();
        this.findCategory();
        this.setScale();
    }
    findCategory() {
        const GLOBALS_NUTRIENTS = ['NIT', 'FOS', 'POT', 'CAR'];
        const catIx = exports.CATEGORIES_LIBRARY.findIndex((cat) => cat.hooks.includes(this.type_code));
        if (catIx != -1) {
            if (GLOBALS_NUTRIENTS.includes(this.code_name)) {
                this.category = 'GS';
            }
            else {
                this.category = exports.CATEGORIES_LIBRARY[catIx].code;
            }
        }
    }
    setScale() {
        this.category !== 'HLT' ? (this.scale = 'std') : (this.type_code === 'BIO' || this.type_code === 'GS') ? (this.scale = 'std') : (this.scale = 'hlt');
        const newScale = this.scale;
        this.samples = this.samples.map((s) => new AreaProjectSamples(Object.assign({}, s)));
        this.samples.forEach((s) => {
            s.setScale(newScale);
        });
    }
    setScore(newScore) {
        this.scoreBC = new Score_1.default(newScore, '');
        this.score = newScore;
        this.rank = colorController.getRankFromScore(newScore);
    }
    get color() {
        return (this.scale === 'hlt') ?
            colorController.getDiseasesColor(colorController.getRankFromScore(this.scoreBC.value).toString()) :
            colorController.getRankColor(colorController.getRankFromScore(this.scoreBC.value).toString());
    }
    get transparency() {
        return (this.scale === 'hlt') ?
            colorController.getRankTransparency(colorController.getRankFromScore(this.scoreBC.value).toString(), 'diseases') :
            colorController.getRankTransparency(colorController.getRankFromScore(this.scoreBC.value).toString(), '');
    }
    get rankLabel() {
        return colorController.getRankLabel(this.rank);
    }
    get rankLabelShort() {
        return colorController.getRankShortNameFromNumber(this.rank);
    }
}
exports.BioMetric = BioMetric;
class PhChMetric extends BeCropMetric {
    constructor(bcObj, phObj) {
        super(bcObj);
        this.visual = phObj.visual || '';
        this.test_name = phObj.test_name || '';
        this.dimension = phObj.dimension || 'phch';
        this.resultOrigin = phObj.resultOrigin || '';
    }
    get color() {
        return colorController.getRankColor(this.rank.toString());
    }
    get transparency() {
        return colorController.getRankTransparency(this.rank.toString());
    }
}
exports.PhChMetric = PhChMetric;
class BeCropComparisonMetric {
    constructor(baseMetric, vsObj) {
        this.baseMetric = baseMetric;
        this.higherIn = vsObj.higherIn || '-';
        this.difference = vsObj.difference || 0;
        this.scoreDefeated = vsObj.scoreDefeated || new Score_1.default(0);
        this.rankDefeated = vsObj.rankDefeated || colorController.getRankFromScore(this.scoreDefeated.value);
        this.samplesDefeated = vsObj.samplesDefeated || new Array();
    }
    get colorDefeated() {
        if ('category' in this.baseMetric) {
            return (this.baseMetric.category === 'HLT') ?
                colorController.getDiseasesColor(colorController.getRankFromScore(this.rankDefeated.toString())) :
                colorController.getRankColor(colorController.getRankFromScore(this.rankDefeated.toString()));
        }
    }
    get transparencyDefeated() {
        if ('category' in this.baseMetric) {
            return (this.baseMetric.category === 'HLT') ?
                colorController.getRankTransparency(colorController.getRankFromScore(this.rankDefeated.toString()), 'diseases') :
                colorController.getRankTransparency(colorController.getRankFromScore(this.rankDefeated.toString()), '');
        }
    }
    get winnerMetric() {
        return this.baseMetric;
    }
    get defeatedMetric() {
        let baseMetric = this.baseMetric;
        if ('category' in baseMetric) {
            let metric = new BioMetric(Object.assign(Object.assign({}, baseMetric), { samples: this.samplesDefeated }), Object.assign({}, baseMetric));
            metric.setScore(this.scoreDefeated.value);
            return metric;
        }
        if ('test_name' in baseMetric) {
            let metric = new PhChMetric(Object.assign(Object.assign({}, baseMetric), { samples: this.samplesDefeated }), Object.assign({}, baseMetric));
            metric.setScore(this.scoreDefeated.value);
            return metric;
        }
    }
}
exports.BeCropComparisonMetric = BeCropComparisonMetric;
class MultiDimmensionalComparison {
    constructor(obj) {
        this.microbiological = (obj === null || obj === void 0 ? void 0 : obj.microbiological) || new BeCropComparisonMetric({}, {});
        this.phch = (obj === null || obj === void 0 ? void 0 : obj.phch) || new BeCropComparisonMetric({}, {});
    }
}
exports.MultiDimmensionalComparison = MultiDimmensionalComparison;
class AreaCertificate {
    constructor(obj) {
        this.category = obj.category || '';
        this.id_report = obj.id_report || -1;
        this.is_public = obj.is_public || false;
        this.score = obj.score || new Score_1.default(-1, 'rate');
        this.valid_until = obj.valid_until || '';
    }
}
exports.AreaCertificate = AreaCertificate;
class PlusReport {
    constructor(obj) {
        this.enabled = obj.enabled || false;
        this.provider = obj.provider || { name: '', logo: '' };
        this.phchMetrics = obj.phchMetrics || new Array();
        this.generalInsights = obj.generalInsights || new Array();
    }
    get hasRanks() {
        // @ts-ignore
        return this.phchMetrics.every((p) => p.rank > 0);
    }
    get metricCatalogue() {
        return [...this.generalInsights, ...this.phchMetrics];
    }
}
exports.PlusReport = PlusReport;
class AreaProjectProposal {
    constructor(obj) {
        this.id = obj.id || -1;
        this.name = obj.name || '';
        this.version = obj.version || 0;
    }
}
exports.AreaProjectProposal = AreaProjectProposal;
class BeCropMetricCategory {
    constructor(obj) {
        this.name = obj.name || '-';
        this.code = obj.code || '-';
        this.order = obj.order || -1;
        this.hooks = obj.hooks || [];
        this.metrics = obj.metrics || [];
        this.lastMetricIx = obj.lastMetricIx || -1;
    }
    hasMetric(metric) {
        if (this.metrics.findIndex((m) => m.baseMetric.name === metric.baseMetric.name) !== -1)
            return true;
        return false;
    }
}
exports.BeCropMetricCategory = BeCropMetricCategory;
class AreaProjectVSPhChMetricCategory {
    constructor(obj) {
        this.name = obj.name || '-';
        this.metrics = obj.metrics || new Array();
    }
}
exports.AreaProjectVSPhChMetricCategory = AreaProjectVSPhChMetricCategory;
class ComparisonReport {
    constructor(mainHighBioMetrics, secondaryHighBioMetrics, mainHighPhChGeneralInsights, mainHighPhChMetrics, secondaryHighPhChGeneralInsights, secondaryHighPhChMetrics, mainHighBioBlocks, secondaryHighBioBlocks, mainHighPhChBlocks, secondaryHighPhChBlocks) {
        this.mainHighBioCategories = [...exports.CATEGORIES_LIBRARY];
        this.secondaryHighBioCategories = [...exports.CATEGORIES_LIBRARY];
        this.mainHighPhChCategories = [];
        this.mainHighPhChCategories.push(new AreaProjectVSPhChMetricCategory({
            name: (0, trans_1.trans)('results_view_map.gi'),
            metrics: mainHighPhChGeneralInsights,
        }));
        this.mainHighPhChCategories.push(new AreaProjectVSPhChMetricCategory({
            name: (0, trans_1.trans)('results_view_map.om'),
            metrics: mainHighPhChMetrics,
        }));
        this.secondaryHighPhChCategories = [];
        this.secondaryHighPhChCategories.push(new AreaProjectVSPhChMetricCategory({
            name: (0, trans_1.trans)('results_view_map.gi'),
            metrics: secondaryHighPhChGeneralInsights,
        }));
        this.secondaryHighPhChCategories.push(new AreaProjectVSPhChMetricCategory({
            name: (0, trans_1.trans)('results_view_map.om'),
            metrics: secondaryHighPhChMetrics,
        }));
        this.buildBioCategories(mainHighBioMetrics, secondaryHighBioMetrics);
        this.mainHighBioBlocks = this.mainHighBioCategories.filter((cat) => cat.metrics.length > 0).map((bmc) => new BeCropMetricsBlock({
            label: bmc.name,
            hook: bmc.code,
            metrics: bmc.metrics
        }));
        this.secondaryHighBioBlocks = this.secondaryHighBioCategories.filter((cat) => cat.metrics.length > 0).map((bmc) => new BeCropMetricsBlock({
            label: bmc.name,
            hook: bmc.code,
            metrics: bmc.metrics
        }));
        this.mainHighPhChBlocks = this.mainHighPhChCategories.filter((cat) => cat.metrics.length > 0).map((bmc) => new BeCropMetricsBlock({
            label: bmc.name,
            hook: bmc.code,
            metrics: bmc.metrics
        }));
        this.secondaryHighPhChBlocks = this.secondaryHighPhChCategories.filter((cat) => cat.metrics.length > 0).map((bmc) => new BeCropMetricsBlock({
            label: bmc.name,
            hook: bmc.code,
            metrics: bmc.metrics
        }));
    }
    get allMetricsCatalogue() {
        let temp = [];
        this.mainHighBioBlocks.forEach((b) => {
            temp = [...temp, ...b.metrics];
        });
        this.secondaryHighBioBlocks.forEach((b) => {
            temp = [...temp, ...b.metrics];
        });
        this.mainHighPhChBlocks.forEach((b) => {
            temp = [...temp, ...b.metrics];
        });
        this.secondaryHighPhChBlocks.forEach((b) => {
            temp = [...temp, ...b.metrics];
        });
        return temp;
    }
    emptyCategories() {
        this.mainHighBioCategories.forEach((c) => (c.metrics = []));
        this.secondaryHighBioCategories.forEach((c) => (c.metrics = []));
    }
    buildBioCategories(mainHigherMetrics, secondaryHigherMetrics) {
        this.emptyCategories();
        let currentOrder = 0;
        const maxMetricsAdded = 3;
        let mainAdded = 0;
        let secondaryAdded = 0;
        const mainCategories = JSON.parse(JSON.stringify(exports.CATEGORIES_LIBRARY)).map((c) => c);
        const main = mainHigherMetrics.sort((a, b) => b.difference - a.difference);
        main.forEach((pm) => {
            // Find Category
            const catIx = mainCategories.findIndex((cat) => cat.code === pm.baseMetric.category);
            // Push Metric
            if (catIx !== -1) {
                const metricToInclude = pm;
                mainAdded < maxMetricsAdded ? (metricToInclude.baseMetric.public = true) : (metricToInclude.baseMetric.public = false);
                mainCategories[catIx].metrics.push(metricToInclude);
                mainAdded += 1;
                // Update Order if it's not already
                if (mainCategories[catIx].order === -1) {
                    mainCategories[catIx].order = currentOrder;
                    currentOrder += 1;
                }
            }
        });
        const secondaryCategories = JSON.parse(JSON.stringify(exports.CATEGORIES_LIBRARY)).map((c) => c);
        const secondary = secondaryHigherMetrics.sort((a, b) => b.difference - a.difference);
        secondary.forEach((pm) => {
            // Find Category
            const catIx = secondaryCategories.findIndex((cat) => cat.code === pm.baseMetric.category);
            // Push Metric
            if (catIx !== -1) {
                const metricToInclude = pm;
                secondaryAdded < maxMetricsAdded ? (metricToInclude.baseMetric.public = true) : (metricToInclude.baseMetric.public = false);
                secondaryCategories[catIx].metrics.push(metricToInclude);
                secondaryAdded += 1;
                // Update Order if it's not already
                if (secondaryCategories[catIx].order === -1) {
                    secondaryCategories[catIx].order = currentOrder;
                    currentOrder += 1;
                }
            }
        });
        this.mainHighBioCategories = mainCategories;
        this.secondaryHighBioCategories = secondaryCategories;
    }
}
exports.ComparisonReport = ComparisonReport;
class BeCropMetricsBlock {
    constructor(obj) {
        this.label = obj.label || '-';
        this.hook = obj.hook || '-';
        this.metrics = obj.metrics || [];
    }
    hasMetric(m) {
        if (this.isBioMetric) {
            const allBioMetrics = this.metrics.filter((metric) => 'category' in metric);
            return allBioMetrics.some((mbio) => mbio.name === m.name);
        }
        else if (this.isPhChMetric) {
            const allPhChMetrics = this.metrics.filter((metric) => 'visual' in metric);
            return allPhChMetrics.some((mph) => mph.name === m.name);
        }
        else if (this.isBeCropComparisonMetric) {
            const allVSMetrics = this.metrics.filter((metric) => 'baseMetric' in metric);
            return allVSMetrics.some((mvs) => mvs.baseMetric.name === m.baseMetric.name);
        }
        return false;
    }
    get isBioMetric() {
        return this.metrics.every((m) => true);
    }
    get isPhChMetric() {
        return this.metrics.every((m) => true);
    }
    get isBeCropComparisonMetric() {
        return this.metrics.every((m) => true);
    }
}
exports.BeCropMetricsBlock = BeCropMetricsBlock;
class AreaGeneralMetrics {
    constructor(obj) {
        var _a, _b;
        this.problematic = [];
        this.no_problematic = [];
        this.problematic = ((_a = obj.problematic) === null || _a === void 0 ? void 0 : _a.map((m) => new BioMetric({
            name: m.name,
            code_name: m.code_name,
            score: Math.round(m.score),
            unit: 'BsC',
            rank: colorController.getRankFromScore(m.score),
            samples: m.samples.map((s) => new AreaProjectSamples({
                code: s.sample_code,
                score: s.score,
                rank: s.rank
            })),
            public: m.show_metric,
            rasterUrl: m.rasterUrl,
            type_code: m.type_code,
            category: new Category({
                name: m.category.name,
                slug: m.category.slug,
            }),
            category_map: new Category({
                name: m.category_map.name,
                slug: m.category_map.slug,
            }),
        }, {
            insights: new AreaProjectAgronomicInsights(this.insightWithOnlyOptimalValues(m)),
            isBeneficial: m.beneficial,
            score: m.score,
            dimension: 'bio',
            raw_rank: m.raw_rank
        }))) || [];
        this.no_problematic = ((_b = obj.no_problematic) === null || _b === void 0 ? void 0 : _b.map((m) => new BioMetric({
            name: m.name,
            code_name: m.code_name,
            score: Math.round(m.score),
            unit: 'BsC',
            rank: colorController.getRankFromScore(m.score),
            samples: m.samples.map((s) => new AreaProjectSamples({
                code: s.sample_code,
                score: s.score,
                rank: s.rank
            })),
            public: m.show_metric,
            rasterUrl: m.rasterUrl,
            type_code: m.type_code,
            category: new Category({
                name: m.category.name,
                slug: m.category.slug,
            }),
            category_map: new Category({
                name: m.category_map.name,
                slug: m.category_map.slug,
            }),
        }, {
            insights: new AreaProjectAgronomicInsights(this.insightWithOnlyOptimalValues(m)),
            isBeneficial: m.beneficial,
            score: m.score,
            dimension: 'bio',
            raw_rank: m.raw_rank
        }))) || [];
    }
    insightWithOnlyOptimalValues(m) {
        const insight = new AreaProjectAgronomicInsights({});
        insight.optimal_values = m.insights.optimal_values;
        return insight;
    }
    getAllMetrics() {
        return [
            ...this.getPrimaryMetrics(),
            ...this.getSecondaryMetrics(),
        ];
    }
    getPrimaryMetrics() {
        return this.problematic.sort((a, b) => a.category - b.category);
    }
    getSecondaryMetrics() {
        return this.no_problematic.sort((a, b) => a.category - b.category);
        ;
    }
    get metricCatalogue() {
        return [
            ...this.problematic,
            ...this.no_problematic
        ];
        //return metrics.sort((a:BioMetric, b:BioMetric) => b.category - a.category)
    }
}
exports.AreaGeneralMetrics = AreaGeneralMetrics;
class AreaFarmCategoryMetrics {
    constructor(name, metrics) {
        this.metrics = [];
        this.name = name || '-';
        this.metrics = metrics.map((m) => {
            return new BioMetric({
                name: m.name,
                code_name: m.code_name,
                score: Math.round(m.score),
                unit: 'BsC',
                rank: colorController.getRankFromScore(m.score),
                samples: (m.samples) ?
                    m.samples.map((s) => new AreaProjectSamples({
                        code: s.sample_code,
                        score: s.score,
                        rank: s.rank
                    })) : [],
                public: m.show_metric,
                rasterUrl: m.rasterUrl,
                type_code: m.type_code,
                category: new Category({
                    name: m.category.name,
                    slug: m.category.slug,
                }),
                category_map: new Category({
                    name: m.category_map.name,
                    slug: m.category_map.slug,
                }),
            }, {
                insights: new AreaProjectAgronomicInsights(m.insights),
                isBeneficial: m.beneficial,
                score: m.score,
                dimension: 'bio',
                raw_rank: m.raw_rank,
                stats: m.statistics,
                resultOrigin: m.result_origin,
                microorganisms: m.microorganisms ?
                    m.microorganisms.map((m) => new Microorganism(m)) :
                    new Array()
            });
        }) || [];
    }
}
exports.AreaFarmCategoryMetrics = AreaFarmCategoryMetrics;
class AreaFarmMetrics {
    constructor(obj) {
        var _a, _b, _c, _d;
        this.top_to_improve = [];
        this.categories = [];
        this.top_to_improve = ((_a = obj.top_to_improve) === null || _a === void 0 ? void 0 : _a.map((category) => new AreaFarmCategoryMetrics(category.name, category.metrics))) || [];
        this.categories = ((_b = obj.categories) === null || _b === void 0 ? void 0 : _b.map((category) => new AreaFarmCategoryMetrics(category.name, category.metrics))) || [];
        (_c = this.categories) === null || _c === void 0 ? void 0 : _c.forEach(category => { var _a; return (_a = category.metrics) === null || _a === void 0 ? void 0 : _a.forEach(metric => metric.public = true); });
        (_d = this.top_to_improve) === null || _d === void 0 ? void 0 : _d.forEach(category => { var _a; return (_a = category.metrics) === null || _a === void 0 ? void 0 : _a.forEach(metric => metric.public = true); });
    }
    getAllMetrics() {
        const metrics = [
            ...this.getPrimaryMetrics(),
            ...this.getSecondaryMetrics(),
        ];
        const unique = [];
        metrics.forEach((metric) => {
            if (!unique.some(u => u.code_name === metric.code_name))
                unique.push(metric);
        });
        return unique;
    }
    getPrimaryMetrics() {
        var _a;
        const metrics = [];
        (_a = this.top_to_improve) === null || _a === void 0 ? void 0 : _a.forEach(category => metrics.push(...category.metrics));
        return metrics;
    }
    getSecondaryMetrics() {
        var _a;
        const metrics = [];
        (_a = this.categories) === null || _a === void 0 ? void 0 : _a.forEach(category => metrics.push(...category.metrics));
        return metrics;
    }
    get metricCatalogue() {
        const metrics = [];
        this.categories.forEach((cat) => metrics.push(...cat.metrics));
        metrics.sort((a, b) => {
            if (a.category === 'HLT')
                return -1;
            if (b.category === 'HLT')
                return 1;
            if (a.category === 'GS')
                return 1;
            if (b.category === 'GS')
                return -1;
            return a.category.localeCompare(b.category);
        });
        return metrics;
    }
}
exports.AreaFarmMetrics = AreaFarmMetrics;
class Microorganism {
    constructor(obj) {
        this.genus = obj.genus || '#genus';
        this.species = obj.species || '#species';
        this.kingdom = obj.kingdom || '#kingdom';
    }
    get name() {
        return `
            ${this.genus.charAt(0).toUpperCase()}${this.genus.slice(1)}
            ${this.species.toLowerCase()} 
        `;
    }
    get nameHTML() {
        return `<p style="font-style:italic">${this.name}</p>`;
    }
}
exports.Microorganism = Microorganism;
class Metric {
    constructor(obj) {
        this.metric_code = obj.metric_code || '';
        this.stats = new IndividualStats_1.BecropStats(obj.stats || {});
        this.agronomicInsights = new AreaProjectAgronomicInsights(obj.agronomic_insights || obj.agronomicInsights || {});
        this.microorganisms = obj.microorganisms || new Array();
        // ##!: Why is it required to use both ways? -- we need to check
    }
}
exports.Metric = Metric;
class ResultsStats {
    constructor(obj) {
        var _a;
        this.metrics = ((_a = obj.metrics) === null || _a === void 0 ? void 0 : _a.map(metric => new Metric(metric))) || Array();
    }
}
exports.ResultsStats = ResultsStats;
class GisField {
    constructor(obj) {
        var _a, _b;
        this.id = obj.id || -1;
        this.name = obj.name || '';
        this.metadata = obj.metadata || { value: 0, unit: '' }; // Metadata class
        this.crop = new Crop_1.default(obj.crop || { id: 0, crop_name: '', logo_name: '' | null, color: '' | null });
        this.farm = obj.farm || { id: 0, name: '', cliend_code: '' };
        this.geodata = obj.geodata || '';
        this.results_stats = new ResultsStats(obj.results_stats || {}); //##! wrong by default element
        this.results_stats_plus = new ResultsStats(obj.results_stats_plus || {}); //##! wrong by default element
        this.needs_maps_results = ((_a = obj.needs_maps_results) === null || _a === void 0 ? void 0 : _a.map((needmap) => new NeedMap_1.NeedMapsFieldCategoryResults(!needmap.category ? this.transformBackendFormat(needmap, obj.id) : needmap))) || new Array();
        this.recommendations = ((_b = obj.recommendations) === null || _b === void 0 ? void 0 : _b.map((recommendation) => new Recommendation_1.default(recommendation.needMap, recommendation.products))) || [];
    }
    transformBackendFormat(needMap, fieldId) {
        return {
            field_id: fieldId,
            category: {
                slug: needMap.slug,
                title: needMap.title,
                caption: needMap.caption,
                enabled: needMap.enabled,
                typeScale: needMap.typeScale,
                reverseScale: needMap.reverseScale
            },
            results: needMap.results,
        };
    }
    isValid() {
        return this.id !== -1;
    }
    getMetricStats(metric_code) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.results_stats) === null || _a === void 0 ? void 0 : _a.metrics) === null || _b === void 0 ? void 0 : _b.find((metric) => metric.metric_code === metric_code)) === null || _c === void 0 ? void 0 : _c.stats) || new IndividualStats_1.BecropStats({});
    }
    getMetricValue(metric_code) {
        var _a;
        return ((_a = this.getMetricStats(metric_code)) === null || _a === void 0 ? void 0 : _a.mean) || -1;
    }
}
exports.GisField = GisField;
class AreaProjectDeliverable {
    constructor(obj) {
        var _a;
        this.categoriesDictionary = exports.CATEGORIES_LIBRARY.map((c) => new BeCropMetricCategory(c));
        this.meta = obj.meta || {
            area_id: -1,
            project_id: -1,
            type: '',
            name: '',
            unit: 'ha',
            extension: '0',
            polygon: '',
            crop: new Crop_1.default({})
        };
        this.needsMaps = (obj.needsMaps) ? obj.needsMaps.map((n) => new NeedMap_1.NeedMap(n)) : new Array();
        (this.meta.acreage = new Acreage_1.default(parseFloat(this.meta.extension), this.meta.unit)),
            (this.metrics = obj.metrics || new AreaGeneralMetrics({}));
        this.certificate = obj.certificate || new AreaCertificate({});
        this.samples = obj.samples || new Array();
        this.proposal = obj.proposal || new AreaProjectProposal({});
        this.plus = obj.plus || new PlusReport({});
        this.categoriesBuilt = this.categoriesDictionary;
        this.bioBlocks = new Array();
        this.phchBlocks = new Array();
        this.recommendationsFeedback = new Recommendations_1.RecommendationsFeedback({});
        this.fields = new Array();
        this.agronomicInsights = new Array();
        this.downloadedInsights = new Array();
        this.gisFields = ((_a = obj.gisFields) === null || _a === void 0 ? void 0 : _a.map((field) => new GisField(field))) || Array();
        this.newRecommendations = obj.recommendations;
        if (Object.keys(obj).length > 0) {
            this.fillCategories();
            this.curateFields();
        }
        if ('categories' in this.metrics || 'top_to_improve' in this.metrics) {
            this.fillCategorizedMetrics();
        }
        else if ('problematic' in this.metrics || 'no_problematic' in this.metrics) {
            this.fillProbMetrics();
        }
        if (this.meta.type === 'farm') {
            this.needsMaps.push(new NeedMap_1.NeedMap({
                slug: 'rate',
                title: this.certificate.category,
                enabled: (this.certificate.category !== '-') ? true : false
            }));
        }
    }
    async downloadRateCertificate() {
        try {
            fetch('/data/results/certificate/' + this.meta.area_id).then((response) => {
                if (response.status === 200) {
                    window.open('/data/results/certificate/' + this.meta.area_id, '_blank');
                }
                else {
                    console.log('error');
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    async toggleVisibility() {
        try {
            await axios_1.default.get('/rate/' + this.certificate.id_report + '/setIsPublished');
        }
        catch (e) {
            console.log(e);
        }
        this.certificate.is_public = !this.certificate.is_public;
    }
    async downloadQRImg() {
        await (0, axios_1.default)({
            url: '/rate/' + this.certificate.id_report + '/qr',
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', `QR_img_${this.meta.name}.png`);
            document.body.appendChild(fileLink);
            fileLink.click();
        })
            .catch((error) => {
            console.log(error);
        });
    }
    addIndividualMetricInFields(metric) {
        this.fields.forEach((f) => {
            const codes = f.sampleCodes;
            const samplesThisMetricAndField = metric.samples.filter((s) => codes.includes(s.code));
            const rawTotalScore = samplesThisMetricAndField.reduce((accum, current) => accum + current.score, 0);
            const rawScore = rawTotalScore / samplesThisMetricAndField.length;
            if ('category' in metric) {
                let newBioMetric = new BioMetric(Object.assign(Object.assign({}, metric), { samples: samplesThisMetricAndField }), Object.assign({}, metric));
                newBioMetric.setScore(rawScore);
                f.metrics.push(newBioMetric);
            }
        });
    }
    addMetricsInFields(metrics) {
        metrics.forEach((m) => this.addIndividualMetricInFields(m));
    }
    /*     findMetric(m: BioMetric | PhChMetric) {
            if('category' in m) {
                const allMetrics = this.metrics.getAllMetrics()
                let foundMetric = allMetrics.find((me:BioMetric) => me.code_name === m.code_name)
                return foundMetric
            }
    
            if('test_name' in m) {
                const allPhChMetrics:PhChMetric = []
                this.phchBlocks.forEach((b:BeCropMetricsBlock) => {
                    allPhChMetrics = [...allPhChMetrics, b.metrics]
                })
                return allPhChMetrics
            }
        } */
    buildMetricsByField(metrics, samples) {
        const allBioMetrics = this.bioBlocks.map((b) => b.metrics);
        const allBioMetricsFlat = allBioMetrics.flat().filter((b) => 'category' in b);
        const allBioMetricsBuilt = allBioMetricsFlat.map((b) => {
            const statsIg = metrics.find((m) => m.metric_code === b.code_name);
            const codes = samples.map((s) => s.code);
            const samplesInField = b.samples.filter((s) => codes.includes(s.code));
            if (statsIg) {
                let newBioMetric = new BioMetric(Object.assign(Object.assign({}, b), { samples: samplesInField }), Object.assign(Object.assign({}, b), { stats: statsIg.stats, insights: statsIg.agronomicInsights, microorganisms: statsIg.microorganisms }));
                newBioMetric.setScore(statsIg.stats.mean);
                return newBioMetric;
            }
            else {
                let newBioMetric = new BioMetric(Object.assign(Object.assign({}, b), { samples: [] }), Object.assign({}, b));
                newBioMetric.setScore(0);
                return newBioMetric;
            }
        });
        return allBioMetricsBuilt;
    }
    buildPhChMetricsByField(metrics, samples) {
        const allPhChMetrics = this.phchBlocks.map((b) => b.metrics);
        const allPhChMetricsFlat = allPhChMetrics.flat().filter((b) => 'test_name' in b);
        const allPhChMetricsBuilt = allPhChMetricsFlat.map((b) => {
            const statsIg = metrics.find((m) => m.metric_code === b.test_name);
            const codes = samples.map((s) => s.code);
            const samplesInField = b.samples.filter((s) => codes.includes(s.code));
            if (statsIg) {
                let newPhChMetric = new PhChMetric(Object.assign(Object.assign({}, b), { samples: samplesInField }), Object.assign(Object.assign({}, b), { stats: statsIg.stats }));
                newPhChMetric.score = statsIg.stats.mean;
                newPhChMetric.rank = -1;
                return newPhChMetric;
            }
            else {
                let newPhChMetric = new PhChMetric(Object.assign(Object.assign({}, b), { samples: [] }), Object.assign({}, b));
                newPhChMetric.score = 0;
                newPhChMetric.rank = -1;
                return newPhChMetric;
            }
        });
        return allPhChMetricsBuilt;
    }
    findSamplesByZone(polygon) {
        const map = MAP_CONTROLLER.map;
        const samplesInside = this.samples.filter((s) => { var _a, _b; return (0, Utils_1.isIntersect)((_a = new format_1.WKT()) === null || _a === void 0 ? void 0 : _a.readFeature(polygon, MAP_CONTROLLER.projections), (_b = new format_1.WKT()) === null || _b === void 0 ? void 0 : _b.readFeature(s.coordenates, MAP_CONTROLLER.projections)); });
        return samplesInside;
    }
    findSampleByMetric(sampleCode, config) {
        if (config.isComparison) {
            if (config.isMainPanel) {
                if (config.dimension === 'bio') {
                    if (config.vsMetric.higherIn !== '-') {
                        if (config.vsMetric.higherIn === 'main') {
                            return config.vsMetric.baseMetric.samples.find((marker) => marker.code === sampleCode);
                        }
                        else {
                            return config.vsMetric.samplesDefeated.find((marker) => marker.code === sampleCode);
                        }
                    }
                }
                else if (config.dimension === 'phch') {
                    if (config.vsPhChMetric.higherIn !== '-') {
                        if (config.vsMetric.higherIn === 'main') {
                            return config.vsMetric.baseMetric.samples.find((marker) => marker.code === sampleCode);
                        }
                        else {
                            return config.vsMetric.samplesDefeated.find((marker) => marker.code === sampleCode);
                        }
                    }
                }
            }
            else {
                if (config.dimension === 'bio') {
                    if (config.vsMetric.higherIn !== '-') {
                        if (config.vsMetric.higherIn === 'main') {
                            return config.vsMetric.samplesDefeated.find((marker) => marker.code === sampleCode);
                        }
                        else {
                            return config.vsMetric.baseMetric.samples.find((marker) => marker.code === sampleCode);
                        }
                    }
                }
                else if (config.dimension === 'phch') {
                    if (config.vsMetric.higherIn === 'main') {
                        return config.vsMetric.samplesDefeated.find((marker) => marker.code === sampleCode);
                    }
                    else {
                        return config.vsMetric.baseMetric.samples.find((marker) => marker.code === sampleCode);
                    }
                }
            }
        }
        else {
            if (config.dimension === 'bio') {
                return config.bioMetric.samples.find((marker) => marker.code === sampleCode);
            }
            else if (config.dimension === 'phch') {
                return config.phchMetric.samples.find((marker) => marker.code === sampleCode);
            }
        }
    }
    buildSamplesByFieldPolygon(polygon) {
        const allSamples = this.samples;
        const samplesInZone = this.findSamplesByZone(polygon);
        const samplesByCode = samplesInZone.map((c) => {
            const sample = allSamples.find((s) => s.code === c.code);
            return sample;
        });
        return samplesByCode;
    }
    buildIndividualMetricByFieldSamples(metric, samples) {
        const codes = samples.map((s) => s.code);
        const samplesInThisField = metric.samples.filter((s) => codes.includes(s.code));
        const rawTotalScore = samplesInThisField.reduce((accum, current) => accum + current.score, 0);
        const rawScore = rawTotalScore / samplesInThisField.length;
        let newBioMetric = new BioMetric(Object.assign(Object.assign({}, metric), { samples: samples }), Object.assign({}, metric));
        newBioMetric.setScore(rawScore);
        return newBioMetric;
    }
    buildMetricsByFieldSamples(samples) {
        const codes = samples.map((s) => s.code);
        const allMetrics = this.metrics.getAllMetrics();
        const allFieldMetrics = allMetrics.map((m) => {
            return this.buildIndividualMetricByFieldSamples(m, samples);
            /*             const sampleMetrics = m.samples.filter((s:AreaProjectSamples) => codes.includes(s.code))
                        const rawTotalScore = sampleMetrics.reduce((accumulator:number, current:AreaProjectSamples) => accumulator + current.score, 0);
                        const rawScore = rawTotalScore / sampleMetrics.length
            
                        let newBioMetric = new BioMetric({
                            ...m,
                            samples: samples,
                        },{
                            ...m
                        })
                        newBioMetric.setScore(rawScore)
            
                        return newBioMetric */
        });
        return allFieldMetrics;
    }
    curateFields() {
        // The idea of this function is to check if project has GISFields
        // If yes -> Convert into Fields
        // If not -> Generate Fields based on the polygon
        if (this.gisFields.length > 0) {
            // Turn GISFields into fields
            const tempFields = this.gisFields.map((gf) => {
                const fieldSamples = this.buildSamplesByFieldPolygon(gf.geodata);
                return new Recommendations_1.FieldRecommendation({
                    areaID: this.meta.area_id,
                    id: gf.id,
                    name: gf.name,
                    acreage: new Acreage_1.default(gf.metadata.extension.value, gf.metadata.extension.unit),
                    polygon: gf.geodata,
                    samples: fieldSamples,
                    crop: gf.crop,
                    hasResults: true,
                    isGISField: true,
                    metrics: [
                        ...this.buildMetricsByField(gf.results_stats.metrics, fieldSamples),
                        ...this.buildPhChMetricsByField(gf.results_stats_plus.metrics, fieldSamples)
                    ],
                    needMaps: gf.needs_maps_results,
                    recommendations: gf.recommendations
                }, []);
            });
            this.fields = tempFields;
        }
        else {
            // Create Fields from polygon
            const polygons = (0, Utils_1.divideGeometry)(this.meta.polygon);
            this.fields = polygons.map((p, i) => {
                const fieldSamples = this.buildSamplesByFieldPolygon(p);
                let tempField = new Recommendations_1.FieldRecommendation({
                    areaID: this.meta.area_id,
                    id: i,
                    name: `${this.meta.name} - Field ${i + 1}`,
                    polygon: p,
                    crop: this.meta.crop,
                    // Need Help for Sample
                    samples: fieldSamples,
                    acreage: new Acreage_1.default({}),
                    isGISField: false,
                    hasResults: false,
                    metrics: this.buildMetricsByFieldSamples(fieldSamples),
                    needMaps: [],
                }, []);
                return tempField;
            });
        }
    }
    fillCategorizedMetrics() {
        var _a, _b;
        const metricsMap = new Map();
        const categories = (_a = this.metrics) === null || _a === void 0 ? void 0 : _a.categories;
        const topToImprove = (_b = this.metrics) === null || _b === void 0 ? void 0 : _b.top_to_improve;
        const addMetricData = (metric, key) => {
            if (!metricsMap.has(metric.code_name)) {
                metricsMap.set(metric.code_name, {
                    code_name: metric.code_name,
                    name: metric.name,
                });
            }
            const existingMetric = metricsMap.get(metric.code_name);
            existingMetric[key] = {
                category: metric.category,
                category_metric_name: metric.category_map.name,
                category_metric_slug: metric.category_map.slug,
            };
        };
        if (categories !== undefined) {
            categories.forEach((category) => {
                category.metrics.forEach((metric) => {
                    addMetricData(metric, 'in_categories');
                });
            });
        }
        if (topToImprove !== undefined) {
            topToImprove.forEach((category) => {
                category.metrics.forEach((metric) => {
                    addMetricData(metric, 'in_top_to_improve');
                });
            });
        }
        this.categorizedMetrics = Array.from(metricsMap.values());
    }
    fillProbMetrics() {
        var _a, _b;
        const metricsMap = new Map();
        const problematic = (_a = this.metrics) === null || _a === void 0 ? void 0 : _a.problematic;
        const noProblematic = (_b = this.metrics) === null || _b === void 0 ? void 0 : _b.no_problematic;
        const addMetricData = (metric, key) => {
            if (!metricsMap.has(metric.code_name)) {
                metricsMap.set(metric.code_name, {
                    code_name: metric.code_name,
                    name: metric.name,
                });
            }
            const existingMetric = metricsMap.get(metric.code_name);
            existingMetric[key] = {
                category: metric.category,
                category_metric_name: metric.category_map.name,
                category_metric_slug: metric.category_map.slug,
            };
        };
        if (noProblematic !== undefined) {
            noProblematic.forEach((metric) => {
                addMetricData(metric, 'in_categories');
            });
        }
        if (problematic !== undefined) {
            problematic.forEach((metric) => {
                addMetricData(metric, 'in_top_to_improve');
            });
        }
        this.categorizedMetrics = Array.from(metricsMap.values());
    }
    fillCategories() {
        if (this.metrics instanceof AreaGeneralMetrics) {
            this.fillCategoriesByGeneralProjects();
        }
        else {
            this.fillCategoriesForFarm();
        }
        this.fillPhChBlocks();
    }
    fillCategoriesByGeneralProjects() {
        this.emptyCategories();
        // Problematic
        const problematic = this.metrics.problematic;
        const probStatus = new BeCropMetricsBlock({
            label: (0, trans_1.trans)('results_view_map.prob'),
            hook: 'prob',
            metrics: new Array(),
        });
        problematic.forEach((pm) => {
            // Find Category
            const catIx = this.categoriesBuilt.findIndex((cat) => cat.code === pm.category);
            // Push Metric
            if (catIx !== -1) {
                const metricToInclude = pm;
                metricToInclude.isBeneficial = false;
                this.categoriesBuilt[catIx].metrics.push(metricToInclude);
            }
            probStatus.metrics.push(pm);
        });
        const benStatus = new BeCropMetricsBlock({
            label: (0, trans_1.trans)('results_view_map.no_prob'),
            hook: 'benef',
            metrics: new Array(),
        });
        const beneficial = this.metrics.no_problematic;
        beneficial.forEach((pm) => {
            // Find Category
            const catIx = this.categoriesBuilt.findIndex((cat) => cat.code === pm.category);
            // Push Metric
            if (catIx !== -1) {
                const metricToInclude = pm;
                metricToInclude.isBeneficial = true;
                this.categoriesBuilt[catIx].metrics.push(metricToInclude);
            }
            benStatus.metrics.push(pm);
        });
        probStatus.metrics.sort((a, b) => {
            return exports.CATEGORIES_ORDER.indexOf(a.category_map.slug) - exports.CATEGORIES_ORDER.indexOf(b.category_map.slug);
        });
        benStatus.metrics.sort((a, b) => {
            return exports.CATEGORIES_ORDER.indexOf(a.category_map.slug) - exports.CATEGORIES_ORDER.indexOf(b.category_map.slug);
        });
        this.bioBlocks.push(probStatus);
        this.bioBlocks.push(benStatus);
    }
    fillCategoriesForFarm() {
        this.emptyCategories();
        const top = {
            label: (0, trans_1.trans)('results_view_map.farm.top_title'),
            hook: 'prob',
            metrics: this.metrics.getPrimaryMetrics(),
        };
        const categories = {
            label: (0, trans_1.trans)('results_view_map.farm.categories_title'),
            hook: 'benef',
            metrics: this.metrics.getSecondaryMetrics()
        };
        top.metrics.sort((a, b) => {
            return exports.CATEGORIES_ORDER.indexOf(a.category_map.slug) - exports.CATEGORIES_ORDER.indexOf(b.category_map.slug);
        });
        categories.metrics.sort((a, b) => {
            return exports.CATEGORIES_ORDER.indexOf(a.category_map.slug) - exports.CATEGORIES_ORDER.indexOf(b.category_map.slug);
        });
        this.bioBlocks.push(top);
        this.bioBlocks.push(categories);
    }
    fillPhChBlocks() {
        if (this.plus.generalInsights.length) {
            const general = {
                label: (0, trans_1.trans)('results_view_map.gi'),
                hook: 'gi',
                metrics: this.plus.generalInsights,
            };
            this.phchBlocks.push(general);
        }
        if (this.plus.phchMetrics.length) {
            const phch = {
                label: (0, trans_1.trans)('results_view_map.om'),
                hook: 'om',
                metrics: this.plus.phchMetrics,
            };
            this.phchBlocks.push(phch);
        }
    }
    emptyCategories() {
        this.categoriesBuilt.forEach((c) => (c.metrics = []));
    }
    /*     generateFields(fields: { polygon: string; points: string[], name:string, id: number, hasResults: boolean }[]) {
            const myFields = fields ? fields : []
            if (myFields.length > 0) {
                if(this.fields.length === 0) {
                    this.fields = myFields.map((f:any, i:number) => new FieldRecommendation({
                        areaID: this.meta.area_id,
                        id: f.id,
                        name: f.name,
                        polygon: f.polygon,
                        crop: f.crop,
                        hasResults: f.hasResults,
                        samples: f.points.map((p:string) => new SampleRecommendation({
                            code: p
                        },{}))
                    }, new Array<Recommendation>()));
    
                    this.fulfillSampleInformationInFields();
                }
            }
            this.fillFieldsWithRecommendations();
        } */
    fulfillSampleInformationInFields() {
        // console.log('Añadiendo Muestras a Fields')
        if (this.fields.length > 0) {
            this.fields.forEach((f) => {
                if (f.samples.length > 0) {
                    f.samples.forEach((s) => {
                        const sampleFound = this.samples.find((ms) => ms.code == s.code);
                        if (sampleFound)
                            s.coordinates = sampleFound.coordenates;
                    });
                }
            });
        }
    }
    fillFieldsWithRecommendations() {
        if (this.fields.length > 0) {
            //console.log('hay fields')
            if (this.recommendationsFeedback.set.recommendations.length > 0) {
                const myRawFields = [...this.fields];
                const myFieldsWithRecs = myRawFields.map((f) => {
                    const myRecommendations = new Array();
                    f.samples.forEach((s) => {
                        const recSample = this.recommendationsFeedback.set.findRecommendationBySample(s.code);
                        recSample.forEach((r) => {
                            // f.recommendations.recommendations.push(r)
                            const newRec = Object.assign({}, r);
                            const mySample = newRec.samples.find((myS) => myS.code === s.code);
                            newRec.samples = [];
                            newRec.samples.push(mySample);
                            const existingRecommendationIx = myRecommendations.findIndex((mr) => r.product.slug === mr.product.slug && r.category.short === mr.category.short);
                            if (existingRecommendationIx !== -1) {
                                myRecommendations[existingRecommendationIx].samples.push(mySample);
                            }
                            else {
                                const existingProductIx = myRecommendations.findIndex((mr) => r.product.slug === mr.product.slug);
                                if (existingProductIx !== -1) {
                                    myRecommendations[existingProductIx].samples.push(mySample);
                                }
                                else {
                                    myRecommendations.push(newRec);
                                }
                            }
                        });
                    });
                    const fieldObj = Object.assign({}, f);
                    /*                     const fieldObj = {
                                            name: f.name,
                                            polygon: f.polygon,
                                            areaID: f.areaID,
                                            samples: f.samples,
                                            crop: f.crop
                                        }; */
                    myRecommendations.forEach((fr) => {
                        let level = fr.samples.reduce((accum, s, i, temp) => {
                            accum += s.level;
                            if (i === temp.length - 1) {
                                return Math.round(accum / temp.length);
                            }
                            else {
                                return accum;
                            }
                        }, 0);
                        if (level < 0)
                            level = 0;
                        fr.level = level;
                    });
                    return new Recommendations_1.FieldRecommendation(fieldObj, myRecommendations);
                });
                this.fields = myFieldsWithRecs;
            }
        }
    }
    findFieldBySample(c) {
        return this.fields.find((f) => f.sampleCodes.includes(c));
    }
    curateLevel(raw) {
        let temp = Math.round(raw);
        if (temp === 0 && raw > 0)
            temp = 1;
        return temp;
    }
    findMetricByCodeName(m) {
        //this.metrics.categories
        const allMetricsRaw = this.metrics.metricCatalogue;
        const allMetrics = JSON.parse(JSON.stringify(allMetricsRaw)).map((me) => new BioMetric(me, me));
        const metric = allMetrics.find((me) => me.code_name == m) || new BioMetric({}, {});
        return metric;
    }
    async loadMetricAgInsightsInAllFields(metric) {
        if (this.gisFields.length === 0) {
            if (this.downloadedInsights.find((ag) => ag.metric.code_name === metric)) {
                const insightsByMetric = this.downloadedInsights.filter((ag) => ag.metric.code_name === metric);
                return insightsByMetric;
            }
            else {
                const fieldsAgInsightsP = this.fields.map(async (f) => {
                    const response = await this.getFieldMetricAgronomicInsight(metric, f.sampleCodes, f.id);
                    response.field = f;
                    return response;
                });
                const fieldsAgInsightsF = await Promise.all(fieldsAgInsightsP);
                const notNullFieldsAgInsights = fieldsAgInsightsF.filter((v) => v.code_name);
                const curatedFieldsAgInsights = notNullFieldsAgInsights.map((a) => new AgInsight({
                    insight: a.insights.insight,
                    field: a.field,
                    metric: new BioMetric({
                        rank: a.rank,
                        code_name: a.code_name,
                        name: a.name,
                    }, {
                        score: a.score,
                        raw_rank: a.raw_rank
                    })
                }));
                this.downloadedInsights = [...this.downloadedInsights, ...curatedFieldsAgInsights];
                this.downloadedInsights = this.downloadedInsights.filter((ag, index, self) => index === self.findIndex((t) => (t.field.fieldName === ag.field.fieldName && t.metric.code_name === ag.metric.code_name)));
                return curatedFieldsAgInsights;
            }
        }
        else {
            if (this.downloadedInsights.find((ag) => ag.metric.code_name === metric)) {
                const insightsByMetric = this.downloadedInsights.filter((ag) => ag.metric.code_name === metric);
                return insightsByMetric;
            }
            else {
                const fields = this.gisFields;
                const insightsByFields = fields.map((field) => ({
                    field_id: field.id,
                    field: field,
                    insights: field.results_stats.metrics.find((me) => me.metric_code === metric)
                })).filter((fwi) => fwi.insights !== undefined);
                if (insightsByFields.length > 0) {
                    let areaMetric = this.findMetricByCodeName(metric);
                    const detectedInsightsForThisMetric = insightsByFields.map((ibf) => {
                        var _a;
                        areaMetric.score = ((_a = ibf.insights) === null || _a === void 0 ? void 0 : _a.stats.mean) || -1;
                        areaMetric.scoreBC = new Score_1.default(ibf.insights.stats.mean, '');
                        areaMetric.rank = colorController.getRankFromScore(areaMetric.score);
                        return new AgInsight({
                            insight: ibf.insights.agronomicInsights.insight,
                            field: ibf.field,
                            metric: areaMetric
                        });
                    }).filter((all) => all.insight.length > 0);
                    detectedInsightsForThisMetric.sort((a, b) => {
                        if (a.field.name.length !== b.field.name.length) {
                            return a.field.name.length - b.field.name.length;
                        }
                        else {
                            if (a.field.name < b.field.name) {
                                return -1;
                            }
                            else if (a.field.name > b.field.name) {
                                return 1;
                            }
                            else {
                                return 0;
                            }
                        }
                    }) || [];
                    this.downloadedInsights = [...this.downloadedInsights, ...detectedInsightsForThisMetric];
                    return detectedInsightsForThisMetric;
                }
                else {
                    return [];
                }
            }
        }
    }
    async getFieldMetricAgronomicInsight(metric, samples, id) {
        // SI HAY GIS FIELDS --> getFieldMetricAgronomicInsightAccurate
        // SI NO HAY GIS FIELDS --> LLAMAR AL METODO getFieldMetricAgronomicInsightBySamples
        if (this.gisFields.length === 0) {
            const ag = await this.getFieldMetricAgronomicInsightBySamples(metric, samples);
            return ag;
        }
    }
    /*     async getFieldMetricAgronomicInsightAccurate(gisFieldID: number, metric: string) {
            const params = {
                gis_field_id: gisFieldID,
                metric: metric
            }
    
            const url = '/data/results/gis-field-report';
    
            try {
                const response = await axios.get(url, { params: params });
                return response.data;
            } catch (error) {
                if (error.response && error.response.status === 403 && error.response.data.message) {
                    return {
                        error: true,
                        message: error.response.data.message
                    };
                } else {
                    return {
                        error: true,
                        message: trans('results_view_map.agronomic_insights_list.error')
                    };
                }
            }
        } */
    async getFieldMetricAgronomicInsightBySamples(metric, samples) {
        const params = {
            project_id: this.meta.project_id.toString(),
            metric: metric,
            samples: samples,
        };
        const url = '/data/results/field-report';
        try {
            const response = await axios_1.default.get(url, { params: params });
            return response.data;
        }
        catch (error) {
            if (error.response && error.response.status === 403 && error.response.data.message) {
                return {
                    error: true,
                    message: error.response.data.message
                };
            }
            else {
                return {
                    error: true,
                    message: (0, trans_1.trans)('results_view_map.agronomic_insights_list.error')
                };
            }
        }
    }
    hasFieldAgInsightForMetric(field, metric) {
        return (this.downloadedInsights.findIndex((ag) => ag.field.name === field.name && metric.code_name === ag.metric.code_name && ag.insight.length > 0) !== -1);
    }
    get compatibleWithRecommendations() {
        const COMPATIBLE = ['farm'];
        return COMPATIBLE.includes(this.meta.type);
    }
    async fetchRecommendations() {
        var _a, _b;
        /*
            Asynchronous function to fetch data
        */
        // console.log('bring recommendations');
        if (!this.compatibleWithRecommendations || this.recommendationsFeedback.brief === 'retrieved')
            return;
        const recommEndpointURL = `/data/results/area/recommendation?gis_area_id=${this.meta.area_id}&project_id=${this.meta.project_id}`;
        // console.log('Trayendo Recomendaciones')
        try {
            const resp = await axios_1.default.post(recommEndpointURL);
            // console.log(resp.data);
            const recomms = new Array();
            (_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.recommendations) === null || _b === void 0 ? void 0 : _b.forEach((cat) => {
                cat.product_groups.forEach((pg) => {
                    const newRec = new Recommendations_1.Recommendation({});
                    newRec.category = new Recommendations_1.MetricCategory({
                        label: cat.label,
                        short: cat.category,
                    });
                    newRec.product = new Recommendations_1.AgInput({
                        hierarchyOrder: pg.hierarchy_order,
                        hierarchyDepth: pg.hierarchy_level,
                        name: pg.group_name,
                        slug: pg.slug,
                        parentSlug: pg.parent_group_slug,
                        avgLevel: pg.average_level,
                    });
                    newRec.samples = pg.samples.map((s) => {
                        const sampleFromLibrary = resp.data.samples.find((sl) => sl.code === s.sample_code);
                        const sampleObj = sampleFromLibrary
                            ? {
                                id: sampleFromLibrary.sample_id,
                                code: sampleFromLibrary.code,
                                coordinates: sampleFromLibrary.coordenates,
                            }
                            : {
                                code: s.sample_code,
                            };
                        const sampleRecObj = sampleFromLibrary
                            ? {
                                level: s.level,
                                status: sampleFromLibrary.status,
                            }
                            : {};
                        return new Recommendations_1.SampleRecommendation(sampleObj, sampleRecObj);
                    });
                    newRec.level = this.curateLevel(pg.samples.reduce((accum, s, i, temp) => {
                        accum += s.level;
                        if (i === temp.length - 1) {
                            return accum / temp.length;
                        }
                        else {
                            return accum;
                        }
                    }, 0));
                    recomms.push(newRec);
                });
            });
            // console.log('Tenemos Recomendaciones!')
            this.recommendationsFeedback = new Recommendations_1.RecommendationsFeedback({
                // retrieved, pending_retrieval, failed
                brief: resp.data.brief,
                // brief: 'failed',
                message: resp.data.message,
                set: new Recommendations_1.RecommendationSet(recomms),
            });
            this.recommendations = this.recommendationsFeedback.set;
            this.fillFieldsWithRecommendations();
        }
        catch (e) {
            console.log(e);
        }
    }
    fieldsWhereAgInputRecommended(ag) {
        return this.fields.filter((f) => f.recommendations.isAgInputRecommended(ag.slug));
    }
    getFieldByName(name) {
        if (this.fields.find((f) => `${f.name}${f.id}` === name)) {
            return this.fields.find((f) => `${f.name}${f.id}` === name);
        }
        return new Recommendations_1.FieldRecommendation({});
    }
    getGisFieldByName(name) {
        if (this.gisFields.find((f) => `${f.name}${f.id}` === name)) {
            return this.gisFields.find((f) => `${f.name}${f.id}` === name);
        }
        return new GisField({});
    }
    openCertificate() {
        if (this.certificate.id_report > 0) {
            window.open(`data/results/certificate/${this.meta.area_id}`, '_blank').focus();
        }
    }
    async toggleCertificateVisibility() {
        if (this.meta.type === 'rate') {
            try {
                const id = this.certificate.id_report;
                await axios_1.default.get('/rate/' + id + '/setIsPublished');
                this.certificate.is_public = !this.certificate.is_public;
            }
            catch (e) {
                console.log(e);
            }
        }
    }
    get cropsInvolved() {
        const cropsInvolved = this.fields.reduce((acc, field) => {
            if (!acc.some((crop) => crop.name === field.crop.name)) {
                acc.push(field.crop);
            }
            return acc;
        }, []);
        return cropsInvolved;
    }
}
exports.AreaProjectDeliverable = AreaProjectDeliverable;
class SideBySideMapState {
    constructor(obj) {
        this.MAXLASTVISITEDITEMS = 3;
        this.farm = obj.farm || new AreaProjectDeliverable({});
        this.availableFarms = obj.availableFarms || new Array();
        this.downloadedFarms = new Array();
        this.metric = obj.metric || new BioMetric({}, {});
        this.availableMetrics = obj.availableMetrics || [];
        this.lastVisitedFarms = new Array();
        this.lastVisitedMetrics = [];
        this.isLoading = false;
        if (this.farm.meta.area_id !== -1) {
            this.downloadedFarms.push(this.farm);
        }
    }
    setFarm(newFarm) {
        const storedIx = this.lastVisitedFarms.findIndex((f) => f.area_id === this.farm.meta.area_id);
        const farmBuilt = (storedIx === -1) ?
            this.availableFarms.find((af) => af.area_id === this.farm.meta.area_id) :
            this.lastVisitedFarms[storedIx];
        if (storedIx !== -1) {
            this.lastVisitedFarms.splice(storedIx, 1);
        }
        this.lastVisitedFarms.unshift(farmBuilt);
        this.lastVisitedFarms = this.lastVisitedFarms.filter((f) => f.area_id !== newFarm.meta.area_id);
        this.lastVisitedFarms = this.lastVisitedFarms.slice(0, this.MAXLASTVISITEDITEMS);
        this.farm = newFarm;
    }
    async onChangeFarm(farmBuilt) {
        // Check if is among downloaded
        // If so, set Farm
        // If not, fetch Farm and set Farm
        const downloadedIx = this.downloadedFarms.findIndex((df) => df.meta.area_id === farmBuilt.area_id && df.meta.project_id === farmBuilt.project_id);
        let newFarm = new AreaProjectDeliverable({});
        if (downloadedIx !== -1) {
            newFarm = this.downloadedFarms[downloadedIx];
        }
        this.setFarm(newFarm);
        this.availableMetrics = this.farm.metrics.metricCatalogue;
        this.metric = this.availableMetrics[0];
        this.lastVisitedMetrics = [];
    }
    setMetric(newMetric) {
        const storedIx = this.lastVisitedMetrics.findIndex((m) => m.code_name === this.metric.code_name);
        if (storedIx !== -1) {
            this.lastVisitedMetrics.splice(storedIx, 1);
        }
        this.lastVisitedMetrics.unshift(this.metric);
        this.lastVisitedMetrics = this.lastVisitedMetrics.filter((m) => m.code_name !== newMetric.code_name);
        this.lastVisitedMetrics = this.lastVisitedMetrics.slice(0, this.MAXLASTVISITEDITEMS);
        this.metric = newMetric;
    }
    onChangeMetric(metric) {
        this.setMetric(metric);
    }
}
exports.SideBySideMapState = SideBySideMapState;
